
import { LINKEDIN_CLIENT_ID, VITE_LINKEDIN_CALLBACK_URL } from "../../utils/appConstant";

function LinkedInLogin() {


  const handleLogin = () => {
    const params = new URLSearchParams({
      response_type: "code",
      client_id: LINKEDIN_CLIENT_ID,
      redirect_uri: VITE_LINKEDIN_CALLBACK_URL,
      scope: "openid email profile"
    });

    window.location.href = `https://www.linkedin.com/oauth/v2/authorization?${params}`;
  };

  return (
    <div className="flex justify-center items-center h-full">
      <button
        onClick={handleLogin}
        className="flex items-center justify-center gap-2 bg-[#0077B5] hover:bg-[#046293] text-[#fff]  rounded-md w-[185px] px-2 py-1   text-sm"
      >
        <img src="https://cdn.worldvectorlogo.com/logos/linkedin-icon-2.svg" alt="LinkedIn" className="w-7 h-7" />
        Sign in with LinkedIn
      </button>
     
    </div>
   
  );
}

export default LinkedInLogin;
